export default __webpack_public_path__ + "static/media/taxi.f4e48a23.svg";